import ApplyContent from './Content';
import ApplyLayout from './components/ApplyLayout';
import ApplyProvider from './context';

const Apply: React.FunctionComponent = function () {
  return (
    <ApplyProvider>
      <ApplyLayout>
        <ApplyContent />
      </ApplyLayout>
    </ApplyProvider>
  );
};

export default Apply;
